"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.throwIfPromiseError = exports.AsyncFunctionException = void 0;
var tslib_1 = require("tslib");
var utils_1 = require("./utils");
var AsyncFunctionException = exports.AsyncFunctionException = /** @class */ (function (_super) {
    tslib_1.__extends(AsyncFunctionException, _super);
    function AsyncFunctionException(message) {
        if (message === void 0) { message = AsyncFunctionException.MESSAGE; }
        return _super.call(this, message) || this;
    }
    AsyncFunctionException.MESSAGE = "'Iterable' can not used with async function.\nIf you want to deal with async function, see: [toAsync](https://fxts.dev/docs/toAsync)";
    return AsyncFunctionException;
}(Error));
var throwIfPromiseError = function (a) {
    if ((0, utils_1.isPromise)(a)) {
        throw new AsyncFunctionException();
    }
    return a;
};
exports.throwIfPromiseError = throwIfPromiseError;
//# sourceMappingURL=error.js.map